import {deleteGroup, deleteTask, newTask, newTaskGroup, tasks, updateTask} from "../../api";

export default {
    state: {
        all: []
    },

    actions: {
        newTaskGroup(context, group) {
            let token = context.getters.getToken.jwt;
            return newTaskGroup({ token, group });
        },

        newTask(context, task) {
            let token = context.getters.getToken.jwt;
            return newTask({ token, task });
        },

        fetchTasks(context, project) {
            let token = context.getters.getToken.jwt;
            return tasks({token, project}).then(r => {
                context.commit("setTasks", r.data);
            })
        },

        updateTask(context, task) {
            let token = context.getters.getToken.jwt;
            return updateTask({token, task});
        },

        deleteTask(context, task) {
            let token = context.getters.getToken.jwt;
            return deleteTask({token, task});
        },

        deleteGroup(context, group) {
            let token = context.getters.getToken.jwt;
            return deleteGroup({token, group});
        }
    },

    mutations: {
        setTasks(state, payload) {
            console.log("setTasks payload", payload);
            state.all = payload;
        },

        clearTasks(state) {
            state.all = [];
        }
    },

    getters: {}
};
